import type {
  BenchSortType,
  ConversionCreditCampaign,
  SortingOption,
} from '#src/__generated__/globalTypes.ts';

import { session } from './index.ts';

export enum IOsMobileAppVersion {
  IOS_1 = 'ios-1',
  IOS_GOLD = 'ios-gold',
}
export type MobileAppVersion = '1' | '2' | '3' | '4' | IOsMobileAppVersion;

type Environment = 'staging' | 'development' | 'production' | 'mockprod';
export type SessionStorageEntries = {
  forcedFlag: Record<string | symbol, string>;
  forcedFlags: Environment;
  sport: string;
  'signup-promo': Pick<ConversionCreditCampaign, 'campaignCode'> & {
    endDate: string;
  };
  mobileApp: MobileAppVersion;
  deeplink: string;
  appBuildVersionNumber: number;
  twa: number;
  leftTwaForOAuth: boolean;
  fcmToken: string;
  googlePlayStoreCountryCode: string;
  sawPaidCardExplanatoryDialog: string;
  'debug-menu-hidden': boolean;
  dismissedLineupPredictionTimerGWs: string[];
  composeTeamSelection: {
    so5LeaderboardSlug: string;
    composeSessionId: string;
    benchObjectIds: Nullable<string>[];
  };
  expandedGroupSlugPerFixture: Record<string, string[]>;
  composeFilters: {
    includeUnavailablePlayers?: boolean;
    includeUsed?: boolean;
    includeNoGame?: boolean;
    startersOnly?: boolean;
    sortType?: { type: BenchSortType; direction: SortingOption };
    starterOddsBasisPointsRange?: { min: number; max: number };
  };
  storefrontCountryCode: string;
  bestPackCardPictureUrl: string;
};

export const sessionStorage = {
  getItem: <K extends keyof SessionStorageEntries>(value: K) =>
    session.getItem(value) as SessionStorageEntries[K] | null,
  setItem: <K extends keyof SessionStorageEntries>(
    key: K,
    value: SessionStorageEntries[K] | null
  ) => session.setItem(key, value),
  removeItem: <K extends keyof SessionStorageEntries>(key: K) =>
    session.removeItem(key),
  key: (index: number) => session.key(index),
  length: session.length,
  clear: session.clear,
};
